import { render, staticRenderFns } from "./ClientWidget.vue?vue&type=template&id=fd4163c2&scoped=true&"
import script from "./ClientWidget.vue?vue&type=script&lang=js&"
export * from "./ClientWidget.vue?vue&type=script&lang=js&"
import style0 from "./ClientWidget.vue?vue&type=style&index=0&id=fd4163c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4163c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd4163c2')) {
      api.createRecord('fd4163c2', component.options)
    } else {
      api.reload('fd4163c2', component.options)
    }
    module.hot.accept("./ClientWidget.vue?vue&type=template&id=fd4163c2&scoped=true&", function () {
      api.rerender('fd4163c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ClientWidget.vue"
export default component.exports